import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import { useCallback } from 'react'
import { currentOrgUpdated } from 'auth/actions'
import { useCurrentOrg } from 'auth/hooks'
import useCreateOrUpdateOrganization from 'volunteering/organizations/hooks/useCreateOrUpdateOrganization'
import { useDispatch } from 'react-redux'
import { useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import OrganizationSettingsModal from 'organization/component/OrganizationSettingsModal'
import { mapOrgToPayload, omitAdminLocaleFields } from '../helpers'
import { useInternationalizationEnabled } from 'i18n/feature'
import { Organization } from 'organization/types'

export const useShowOrganizationSettingsEdit = (
  org?: Organization,
  handleDispatchOrganization?: (value: Organization) => void,
) => {
  const showEditOrgSettings = useShowPrompt(OrganizationSettingsModal)
  const curOrganization = useCurrentOrg()
  const organization = org ?? curOrganization
  const createOrUpdateOrganization = useCreateOrUpdateOrganization()
  const dispatch = useDispatch()
  const createNotification = useCreateApiNotification()
  const internationalizationEnabled = useInternationalizationEnabled()
  return useCallback(async () => {
    const payload = await showEditOrgSettings({ organization: organization })
    const gps = payload.address?.geofencing?.location?.coordinates
    if (gps) {
      payload.address.gps = gps
    } else if (organization.location && organization.location.coordinates) {
      const [lng, lat] = organization.location?.coordinates
      payload.address.gps = { lat, lng }
    }
    const notification = createNotification(`Saving Organization`)
    try {
      let updatePayload = { ...mapOrgToPayload(organization), ...payload }
      if (!internationalizationEnabled) {
        updatePayload = omitAdminLocaleFields(updatePayload)
      }
      const updatedOrg = await createOrUpdateOrganization(updatePayload, organization.id)
      if (!handleDispatchOrganization) {
        if (organization.id === curOrganization.id) {
          dispatch(currentOrgUpdated(updatedOrg))
        }
      } else {
        handleDispatchOrganization(updatedOrg)
      }
      notification.onSuccess('Organization saved successfully')
    } catch (e) {
      notification.onError('Failed to save organization', e)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, internationalizationEnabled])
}
